import React, { useMemo } from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import messages from './messages';

const Label = styled.div`
  display: inline-block;
  width: 4.5em;
  ::after {
    content: ':';
  }
`;

export function ElevationTooltip(props) {
  const { active, payload, label, intl } = props;
  return useMemo(
    () => {
      if (!active || !payload || payload.length === 0) {
        return null;
      }
      const { elevation, distance, gradient } = payload[0].payload;
      return (
        <div className="bg-white p-2 border rounded">
          <div>
            <Label>{intl.formatMessage(messages.distance)}</Label>
            {distance.toFixed(1)} km
          </div>
          <div>
            <Label>{intl.formatMessage(messages.elevation)}</Label>
            {elevation} m
          </div>
          <div>
            <Label>{intl.formatMessage(messages.gradient)}</Label>
            {(gradient * 100).toFixed(1)}%
          </div>
        </div>
      );
    },
    [label],
  );
}

ElevationTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.number,
};

export default injectIntl(ElevationTooltip);
